$(function() {
    // Initialize
    $("#buscador").autocomplete({
        source: function(request, response) {
            // Fetch data
            $.ajax({
                url: "/views/layouts/components/_search.php",
                type: "post",
                dataType: "json",
                data: {
                    search: request.term
                },
                success: function(data) {
                    response(data);
                }
            });
        },
        select: function(event, ui) {
            window.location.href = 'https://www.grupoava.com/blog/post/' + ui.item.id;
            return false;
        }
    });
});


// WEBPACK FOOTER //
// ./assets/js/autocompletar.js